/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lastname_Placeholder1Inputs */

const en_lastname_placeholder1 = /** @type {(inputs: Lastname_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. Mustermann`)
};

const de_lastname_placeholder1 = /** @type {(inputs: Lastname_Placeholder1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z.B. Mustermann`)
};

/**
* | output |
* | --- |
* | "e.g. Mustermann" |
*
* @param {Lastname_Placeholder1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const lastname_placeholder1 = /** @type {((inputs?: Lastname_Placeholder1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lastname_Placeholder1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_lastname_placeholder1(inputs)
	return en_lastname_placeholder1(inputs)
});
export { lastname_placeholder1 as "lastName_placeholder" }